import React from 'react';

export type AnnouncementIconProps = React.HTMLProps<SVGSVGElement>;

export function AnnouncementIcon({ ...props }: AnnouncementIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <g id="Group_17751" data-name="Group 17751" transform="translate(1130 11390) rotate(180)">
        <g
          id="Rectangle_12080"
          data-name="Rectangle 12080"
          transform="translate(1110 11370)"
          fill="#ff3b30"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="20" height="20" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
        </g>
        <path
          id="Path_41570"
          data-name="Path 41570"
          d="M13.75,10.833c1.608,0,2.917-2.425,2.917-5.417S15.358,0,13.75,0m0,10.833c-1.608,0-2.917-2.425-2.917-5.417S12.142,0,13.75,0m0,10.833L2.867,8.858A6.1,6.1,0,0,1,1.4,8.492,2.534,2.534,0,0,1,.092,6.933,6.238,6.238,0,0,1,0,5.417,6.238,6.238,0,0,1,.092,3.9,2.533,2.533,0,0,1,1.4,2.342a6.094,6.094,0,0,1,1.467-.367L13.75,0M2.5,9.167l.325,4.592a2.144,2.144,0,0,0,.142.825.838.838,0,0,0,.367.333A1.976,1.976,0,0,0,4.158,15H5.642a2.1,2.1,0,0,0,.933-.1.8.8,0,0,0,.367-.392,2.089,2.089,0,0,0,.033-.942L6.667,9.583"
          transform="translate(1128.333 11388.333) rotate(180)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
        <ellipse
          id="Ellipse_1976"
          data-name="Ellipse 1976"
          cx="2.5"
          cy="4.583"
          rx="2.5"
          ry="4.583"
          transform="translate(1112.083 11378.333)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}
